<div class="breadcrumbtxtcolor" fxlayout="row" fxlayoutalign="start center">
  <div id="breadcrumb-position" *ngFor="let nevil of sharedService.getNevil(); let i = index">

    <span>{{nevil.nivel1}}</span>
    <mat-icon *ngIf="nevil.nivel2 != null"
      class="s-16 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">chevron_right
    </mat-icon>
    <span>{{nevil.nivel2}}</span>
    <mat-icon  *ngIf="nevil.nivel3 != null"
      class="s-16 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">chevron_right
    </mat-icon>
    <span>{{nevil.nivel3}}</span>
    <mat-icon  *ngIf="nevil.nivel4 != null"
      class="s-16 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">chevron_right
    </mat-icon>
    <span>{{nevil.nivel4}}</span>
    <mat-icon *ngIf="nevil.nivel5 != null"
      class="s-16 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">chevron_right
    </mat-icon>
    <span>{{nevil.nivel5}}</span>
  </div>
</div>